import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const CampaignsMonitoringService = {

  getActiveSends: (accountId: number) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}base-clients/v4.0/get-sends-active/${accountId}`
    );
  },

  abortCampaign: (accountId: number, campaignId: number) => {
    return HTTP.put<any, any>(
      `${API_ENDPOINT.CORE}base-clients/v4.0/abort-send/${accountId}/${campaignId}`
    );
  },
};
